import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_96259666 from 'nuxt_plugin_plugin_96259666' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_vlazyload_034acae9 from 'nuxt_plugin_vlazyload_034acae9' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_0741603a from 'nuxt_plugin_cookieuniversalnuxt_0741603a' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_7c0b863b from 'nuxt_plugin_axios_7c0b863b' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_metaplugin_21f218aa from 'nuxt_plugin_metaplugin_21f218aa' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_distplugin3f94e184_7398942a from 'nuxt_plugin_distplugin3f94e184_7398942a' // Source: ./dist.plugin.3f94e184.mjs (mode: 'all')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../app/plugins/vee-validate (mode: 'all')
import nuxt_plugin_injector_68ab1928 from 'nuxt_plugin_injector_68ab1928' // Source: ../app/plugins/injector (mode: 'all')
import nuxt_plugin_icons_229035a6 from 'nuxt_plugin_icons_229035a6' // Source: ../app/plugins/icons (mode: 'all')
import nuxt_plugin_gtag_926ba472 from 'nuxt_plugin_gtag_926ba472' // Source: ../app/plugins/gtag (mode: 'client')
import nuxt_plugin_appinit_cace89a0 from 'nuxt_plugin_appinit_cace89a0' // Source: ../app/plugins/app-init (mode: 'all')
import nuxt_plugin_meta_3a45df1f from 'nuxt_plugin_meta_3a45df1f' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Home","titleTemplate":"%s - Peregre Works","meta":[{"hid":"charset","charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"facebook-domain-verification","content":"51xii8b0tsvshckfggrkwmkytm2m6p"},{"name":"msapplication-TileColor","content":"FFFFFF"},{"name":"theme-color","content":"FFFFFF"}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Ftokyojob-public.s3.ap-northeast-1.amazonaws.com\u002Ficons\u002Ffavicons\u002Fperegreworks\u002Ffavicon.ico","sizes":"16x16"},{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Ftokyojob-public.s3.ap-northeast-1.amazonaws.com\u002Ficons\u002Ffavicons\u002Fperegreworks\u002Ffavicon-16x16.png","sizes":"16x16"},{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Ftokyojob-public.s3.ap-northeast-1.amazonaws.com\u002Ficons\u002Ffavicons\u002Fperegreworks\u002Ffavicon-32x32.png","sizes":"32x32"},{"rel":"apple-touch-icon","href":"https:\u002F\u002Ftokyojob-public.s3.ap-northeast-1.amazonaws.com\u002Ficons\u002Ffavicons\u002Fperegreworks\u002Fapple-touch-icon.png","sizes":"180x180"},{"rel":"manifest","href":"https:\u002F\u002Ftokyojob-public.s3.ap-northeast-1.amazonaws.com\u002Ficons\u002Ffavicons\u002Fperegreworks\u002Fsite.webmanifest","color":"#5bbad5"},{"rel":"mask-icon","href":"https:\u002F\u002Ftokyojob-public.s3.ap-northeast-1.amazonaws.com\u002Ficons\u002Ffavicons\u002Fperegreworks\u002Fsafari-pinned-tab.svg","color":"#5bbad5"}],"script":[{"src":"https:\u002F\u002Fkit.fontawesome.com\u002F5f48100a3c.js","crossOrigin":"anonymous"},{"src":"data:text\u002Fjavascript;base64,CiAgICAoZnVuY3Rpb24odyxkLHMsbCxpKXt3W2xdPXdbbF18fFtdO3dbbF0ucHVzaCh7J2d0bS5zdGFydCc6CiAgICAgIG5ldyBEYXRlKCkuZ2V0VGltZSgpLGV2ZW50OidndG0uanMnfSk7dmFyIGY9ZC5nZXRFbGVtZW50c0J5VGFnTmFtZShzKVswXSwKICAgICAgaj1kLmNyZWF0ZUVsZW1lbnQocyksZGw9bCE9J2RhdGFMYXllcic\u002FJyZsPScrbDonJztqLmFzeW5jPXRydWU7ai5zcmM9CiAgICAgICdodHRwczovL3d3dy5nb29nbGV0YWdtYW5hZ2VyLmNvbS9ndG0uanM\u002FaWQ9JytpK2RsO2YucGFyZW50Tm9kZS5pbnNlcnRCZWZvcmUoaixmKTsKICAgICAgfSkod2luZG93LGRvY3VtZW50LCdzY3JpcHQnLCdkYXRhTGF5ZXInLCdHVE0tTVJRSFA1NCcpOwogICAgICA=","hid":"gtagScript"}],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_96259666 === 'function') {
    await nuxt_plugin_plugin_96259666(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_034acae9 === 'function') {
    await nuxt_plugin_vlazyload_034acae9(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_0741603a === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_0741603a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7c0b863b === 'function') {
    await nuxt_plugin_axios_7c0b863b(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_21f218aa === 'function') {
    await nuxt_plugin_metaplugin_21f218aa(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin3f94e184_7398942a === 'function') {
    await nuxt_plugin_distplugin3f94e184_7398942a(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (typeof nuxt_plugin_injector_68ab1928 === 'function') {
    await nuxt_plugin_injector_68ab1928(app.context, inject)
  }

  if (typeof nuxt_plugin_icons_229035a6 === 'function') {
    await nuxt_plugin_icons_229035a6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_926ba472 === 'function') {
    await nuxt_plugin_gtag_926ba472(app.context, inject)
  }

  if (typeof nuxt_plugin_appinit_cace89a0 === 'function') {
    await nuxt_plugin_appinit_cace89a0(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_3a45df1f === 'function') {
    await nuxt_plugin_meta_3a45df1f(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
